
import * as defaultImport from "@splunk/react-icons/ChevronRight";
export * from "@splunk/react-icons/ChevronRight";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
